import styled from 'styled-components';

interface Props {
  formItemLast?: boolean;
}

export default styled.section<Props>`
  margin-bottom: ${({ formItemLast }) => (formItemLast ? 48 - 24 : 48)}px;
`;
